export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const el = document.querySelector(target);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden bg-background-950"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20cinematic%20home%20theater%20scene%20with%20a%20large%20screen%20displaying%20vibrant%20movie%20visuals%2C%20soft%20warm%20amber%20and%20deep%20red%20ambient%20lighting%2C%20cozy%20dark%20room%20with%20subtle%20decorative%20elements%2C%20elegant%20entertainment%20space%2C%20rich%20textures%2C%20atmospheric%20glow%2C%20professional%20cinema%20aesthetic%2C%20warm%20toned%20photography&width=1600&height=900&seq=hero-bg-90movies&orientation=landscape"
          alt="90影视高清观影体验"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/40"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 max-w-[1440px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-14 py-16 md:py-20">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium text-accent-300 bg-accent-500/15 rounded-full border border-accent-500/25 mb-5 whitespace-nowrap">
              🔔 最新地址已更新 · 安全访问
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-3">
              90影视 — 高清电影电视剧免费在线观看
            </h1>

            <p className="text-sm md:text-base text-white/70 font-heading italic mb-6">
              海量影视资源 · 全集不缓冲 · 多端同步观影
            </p>

            <p className="text-sm md:text-base text-white/60 leading-relaxed max-w-[580px] mx-auto lg:mx-0 mb-7">
              90影视官网入口提供最新最全的高清电影、电视剧、综艺、动漫等海量资源，每日更新同步播出。
              支持网页端、移动端和APP多平台访问，无需注册即可免费在线观看。本站持续更新最新地址，
              确保用户随时随地畅享流畅观影体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              <div className="flex items-center gap-1.5 text-white/80 text-xs md:text-sm">
                <span className="w-2 h-2 rounded-full bg-green-400 inline-block"></span>
                <span>日更新 300+ 部</span>
              </div>
              <div className="flex items-center gap-1.5 text-white/80 text-xs md:text-sm">
                <span className="w-2 h-2 rounded-full bg-accent-400 inline-block"></span>
                <span>覆盖 12 个分类</span>
              </div>
              <div className="flex items-center gap-1.5 text-white/80 text-xs md:text-sm">
                <span className="w-2 h-2 rounded-full bg-primary-400 inline-block"></span>
                <span>全网高清片源</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => handleScroll(e, '#index')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3 bg-primary-500 text-white text-sm md:text-base font-semibold rounded-md hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line w-5 h-5 flex items-center justify-center"></i>
                立即观影
              </a>
              <a
                href="#app"
                onClick={(e) => handleScroll(e, '#app')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3 bg-white/10 text-white text-sm md:text-base font-medium rounded-md border border-white/20 hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-smartphone-line w-5 h-5 flex items-center justify-center"></i>
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:flex items-center justify-center">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20luxurious%20modern%20living%20room%20with%20a%20large%20flat%20screen%20TV%20showcasing%20colorful%20subtle%20movie%20visuals%2C%20warm%20ambient%20lighting%20with%20deep%20crimson%20and%20golden%20accents%2C%20cozy%20atmosphere%2C%20modern%20minimalist%20interior%20design%2C%20comfortable%20viewing%20environment%2C%20cinematic%20aesthetic&width=900&height=675&seq=hero-visual-90movies&orientation=landscape"
                alt="90影视多端观影体验"
                className="w-full h-full object-cover rounded-lg"
              />
              <div className="absolute inset-0 rounded-lg ring-1 ring-inset ring-white/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}